import type { RestorationPost } from "@/lib/server-actions/restoration/_shared";

/**
 * JCG-1570: 복원 게시물 정렬 규칙.
 * 1) 관리자 게시물(`post_status != null`, 확정/종합중 모두)은 순투표수와 무관하게 항상 최상단.
 *    확정이 종합중보다 먼저 온다.
 * 2) 순투표수(`up_count - down_count`) 내림차순.
 * 3) 동점 시 `created_at` 내림차순(최신순).
 *
 * 원본 배열은 변경하지 않는다(순수 함수).
 */
export function sortRestorationPosts<T extends RestorationPost>(
  posts: readonly T[]
): T[] {
  return [...posts].sort(compareRestorationPosts);
}

export function compareRestorationPosts(
  a: RestorationPost,
  b: RestorationPost
): number {
  const aAdmin = a.post_status !== null;
  const bAdmin = b.post_status !== null;
  if (aAdmin !== bAdmin) {
    return aAdmin ? -1 : 1;
  }
  if (aAdmin && bAdmin && a.post_status !== b.post_status) {
    // 확정(0) → 종합중(1) 순
    return a.post_status === "confirmed" ? -1 : 1;
  }
  const netA = (a.up_count ?? 0) - (a.down_count ?? 0);
  const netB = (b.up_count ?? 0) - (b.down_count ?? 0);
  if (netA !== netB) return netB - netA;
  const tA = Date.parse(a.created_at);
  const tB = Date.parse(b.created_at);
  return tB - tA;
}
